export { default as RoleList } from './RoleList';



// WEBPACK FOOTER //
// ./src/modules/role/pages/index.js